import * as Yup from 'yup';

import { VALIDATIONS_ERROR } from '~constants/index';

export const FIELDS_NAME = {
  ASSIGNED_USER: 'assignedUser',
} as const;

export const initialValues = {
  [FIELDS_NAME.ASSIGNED_USER]: '',
};

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.ASSIGNED_USER]: Yup.string().required(
    VALIDATIONS_ERROR.REQUIRED,
  ),
});
